import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../../components/Layout/Layout';
import { HostingService } from '../../services/hostingService';
import "./index.css";
import HeyhoCall from '../../components/Generic/HeyhoCall/HeyhoCall';
import SideModal from '../../components/Layout/SideModal/SideModal';

//Redux
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { UserState } from '../../store/reducers/userReducer';
import { PrefState } from '../../store/reducers/prefReducer';
import { FilterState, setFilterActive } from '../../store/reducers/filterReducer';

import { InputField, SelectField } from '../../components/Form/Input';
import LCFlexContainer from '../../components/Layout/LCFlexContainer';
import LCFlexItem from '../../components/Layout/LCFlexItem';
import { VNet, VNetSubnet } from './model/VNetResponse';
import LcIconLink from '../../components/Generic/LcIconLink';
import { useSnackbar } from 'notistack';
import { useParams } from 'react-router-dom';
import history from '../../history'
import DialogConfirmForm from '../../components/Layout/Dialog/DialogConfirmForm';
import LcTooltip from '../../components/Generic/LcTooltip';
import LcInfiniteTable from '../../components/Data/LcInfiniteTable';
import LcLoading from '../../components/Generic/LcLoading';
import { PPGrid, PPIconLink, PPInput, PPModal } from 'processor-plataform-ui';
import { join } from 'path';
import LcTable from '../../components/Data/LcTable';
import { CacheManagerService } from '../../services/cacheManagerService';
import Confirmation from '../../components/Dialog/Confirmation';
import LCDashboard from '../../components/Data/Dashboard/LCDashboard';
import { FilterLcInfiniteTable } from '../../components/Data/Dashboard/LCDashboard/FilterLcInfiniteTable';
import HeyHoNewRequest, { FormDataHeyho } from '../../components/Generic/HeyHoNewRequest';

interface HostingDetails {
    nome: string,
    hostname: string,
    situacao: string,
    tamanho: string,
    ipPublico: string,
    ipPrivado: string,
    nomePublico: string,
    assinaturaNome: string,
}

interface VM {
    size?: string,
    signature?: string,
    vnet?: string,
    subnet?: string,
    so?: string,
    name?: string,
    contract?: string,
    environment?: string
}

interface Param {
    type: string;
}

const Hosting: React.FC = (props) => {

    const user = useSelector<RootState, UserState>(state => state.user);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const dispatch = useDispatch();

    const { type } = useParams<Param>();
    const [typeLC, setTypeLC] = useState<string>(type == "1" ? "17" : "6");
    //const pageTitle = type == '0' ? 'Hosting' : 'Admin';
    const [filterSearch, setfilterSearch] = React.useState<string>();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [hostingLastUpdate, setHostingLastUpdate] = useState<string>('');
    const [hostingViewResponses, setHostingViewResponses] = useState<any[]>([]);
    const [hostingViewResponsesFiltered, setHostingViewResponsesFiltered] = useState<any[]>([]);

    const [hostingLength, setHostingLength] = useState<number>(0);


    // Estados filtros
    const [filter_nome, setFilter_nome] = useState<string>('');
    const [filter_hostname, setFilter_hostname] = useState<string>('');
    const [filter_assinaturaNome, setFilter_assinaturaNome] = useState<string>('');
    const [filter_situacao, setFilter_situacao] = useState<string>('');


    //const [visibleHostingViewResponsesFiltered, setVisibleHostingViewResponsesFiltered] = useState<any[]>([]);
    const [filterPage, setFilterPage] = useState<{
        size: number,
        term: string,
        clientGroupId: string,
        isLinked: boolean,
        column: string,
        direction: string
    }>({
        size: 20,
        term: "",
        clientGroupId: "",
        isLinked: true,
        column: "",
        direction: "asc"
    });

    const [VNets, setVNets] = useState<VNet[]>([]);
    const [VNetsLoadings, setVNetsLoading] = useState<boolean>(false);
    const [VMSizeSelect, setVMSizeSelect] = useState<{ value: string, name: string }[]>([]);
    const [VNetsSelect, setVNetsSelect] = useState<{ value: string, name: string }[]>();
    const [SubnetSelect, setSubnetSelect] = useState<{ value: string, name: string }[]>([]);
    const [ContractsSelect, setContractsSelect] = useState<{ value: string, name: string }[]>([]);
    const [SubscriptionsSelect, setSubscriptionsSelect] = useState<{ value: string, name: string }[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [vhds, setVhds] = useState<any[]>([]);
    const [LoadingForm, setLoadingForm] = useState<boolean>(false);
    const [MessageSuccess, setMessageSuccess] = useState<string>('');
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const [modalVisibleHeyHoCall, setModalVisibleHeyHoCall] = useState<boolean>(false);
    const [modalVisibleDetails, setModalVisibleDetails] = useState<boolean>(false);
    const [hostingDetails, setHostingDetails] = useState<HostingDetails>();
    const [open, setOpen] = useState<boolean>(false);
    const [vmConfirmationName, setVMConfirmationName] = useState('');
    const [openDelete, setOpenDelete] = React.useState<boolean>(false);
    const [VMOperation, setVMOperation] = React.useState<number>();
    const [SelectedRow, setSelectedRow] = React.useState<any>();
    const [lastUpdate, setLastUpdate] = useState<string>("");

    const cacheManagerService = new CacheManagerService(props);

    const refreshLastUpdate = () => {
        cacheManagerService.LastSyncUpdate("LiveCloudSyncHosting", "VirtualMachineBase")
            .then(response => {
                setLastUpdate(response.data);
            })
            .catch((err) => {
                console.warn(err);
                setLastUpdate(new Date().toISOString());
            })
    }
    const [formData, setFormData] = useState<FormDataHeyho>({
        title: '',
        description: '',
        gtmType: typeLC
    });

    useEffect(() => {
        setFormData({
            title: ``,
            description: ``,
            gtmType: typeLC
        });
    }, [typeLC]);

    useEffect(() => {
        return history.listen((location) => {
            (location.pathname.toLowerCase().indexOf("0") >= 0) && setTypeLC("6");
            (location.pathname.toLowerCase().indexOf("1") >= 0) && setTypeLC("117");
        })
    }, [history, props]);

    const service = new HostingService(props);

    const successMessage = async (action: string) => {
        enqueueSnackbar(`${action}`, {
            variant: 'success',
            preventDuplicate: true,
            persist: false,
            autoHideDuration: 10000

        })
    }

    const warningMessage = async (action: string) => {
        enqueueSnackbar(`${action}`, {
            variant: 'warning',
            preventDuplicate: true,
            persist: false,
            autoHideDuration: 15000
        })
    }

    const errorMessage = async (action: string) => {
        enqueueSnackbar(`${action}`, {
            variant: 'error',
            preventDuplicate: true,
            persist: false,
            autoHideDuration: 15000
        })
    }

    const openModalDetails = (row: any) => {
        setHostingDetails(row);
        setModalVisibleDetails(true);
    }

    const openModalVHDs = (row: any) => {
        setVhds(row.vhd);
        setModalVisible(true)
    }

    const connect = (row: any) => {
        service.Connect(row.hostname, (row.serviceName ?? row.hostname), row.hostname, (row.deploymentName ?? row.hostname), (row.virtualMachineName ?? row.hostname), row.assinaturaId, true, row.ipPublico);
    }

    const edit = (row: any) => {
        setFormData({
            title: `Editar ${row.hostname}`,
            description: `Nome da máquina (hostname):${row.hostname} \r\nTamanho (small / medium / large):  \r\nTamanho de armazenamento (GB): `,
            gtmType: typeLC
        });
        setModalVisibleHeyHoCall(true)
    }

    const deleteMachine = (row: any) => {
        setFormData({
            title: `Deletar ${row.hostname}`,
            description: ``,
            gtmType: typeLC
        });

        setModalVisibleHeyHoCall(true)
    }

    const updateRowSituacao = (row: any) => {
        setIsLoading(true);
        setHostingViewResponsesFiltered([]);
        setHostingViewResponses([]);

        const hostingViewResponsesTemp: any[] = hostingViewResponses;
        hostingViewResponsesTemp.map((item: any) => {
            if (item.hostname == row.hostname) {
                item.situacao = row.situacao;
            }
        });
        setHostingViewResponses(hostingViewResponsesTemp);

        const hostingViewResponsesFilteredTemp: any[] = hostingViewResponsesFiltered;
        hostingViewResponsesFilteredTemp.map((item: any) => {
            if (item.hostname == row.hostname) {
                item.situacao = row.situacao;
            }
        });


        setHostingViewResponsesFiltered(hostingViewResponsesTemp);
        setIsLoading(false);
    }

    const loadAllVMS = () => {
        setIsLoading(true);
        setHostingViewResponses([]);
        setHostingViewResponsesFiltered([]);

        // true: dados do último Sync | false: dados atuais
        service.GetAllVMs(false)
            .then(response => {
                setHostingLastUpdate(response[0].referenceDate)
                setHostingViewResponses(response);
                setHostingViewResponsesFiltered(response);
                setIsLoading(false);
            })
            .catch(error => {
                console.warn(error);
                setIsLoading(false);
            })
    }

    useEffect(() => {
        loadAllVMS();
        refreshLastUpdate();
    }, [user.ClientGroupSelected, user.refreshFlag, type]);

    // CONSULTA INICIAL
    useEffect(() => {
        if (!isLoading)
            loadAllVMS();
    }, [filterSearch]);

    useEffect(() => {
        let filtered = hostingViewResponses.filter((p: any) => {
            const nomeMatch = filter_nome ? p.nome?.toLowerCase().includes(filter_nome.toLowerCase()) : true;
            const hostnameMatch = filter_hostname ? p.hostname?.toLowerCase().includes(filter_hostname.toLowerCase()) : true;
            const assinaturaNomeMatch = filter_assinaturaNome ? p.assinaturaNome?.toLowerCase().includes(filter_assinaturaNome.toLowerCase()) : true;
            const situacaoMatch = filter_situacao ? p.situacao === filter_situacao : true;

            return nomeMatch && hostnameMatch && assinaturaNomeMatch && situacaoMatch;
        }).sort((a: any, b: any) => {
            if (filterPage.direction === 'asc') {
                return a[filterPage.column] > b[filterPage.column] ? 1 : -1;
            } else {
                return a[filterPage.column] < b[filterPage.column] ? 1 : -1;
            }
        });

        setHostingViewResponsesFiltered(filtered);
    }, [filterPage, hostingViewResponses, filter_nome, filter_hostname, filter_assinaturaNome, filter_situacao]);

    const openVHDsLinha = (row: any) => {
        let rowTemp = hostingViewResponsesFiltered.find(r => r.id == row.id);
        openModalVHDs(rowTemp);
    }

    const conectarLinha = (row: any) => {
        let rowTemp = hostingViewResponsesFiltered.find(r => r.id == row.id);
        connect(rowTemp)
    }

    const editarLinha = (row: any) => {
        let rowTemp = hostingViewResponsesFiltered.find(r => r.id == row.id);
        edit(rowTemp);
    }

    const detalhesLinha = (row: any) => {
        let rowTemp = hostingViewResponsesFiltered.find(r => r.id == row.id);
        openModalDetails(rowTemp);
    }

    const ligarLinha = (row: any) => {
        let rowTemp = hostingViewResponsesFiltered.find(r => r.id == row.id);
        setSelectedRow(rowTemp);
        setVMOperation(1);
        setOpen(true);
    }

    const desligarLinha = (row: any) => {
        let rowTemp = hostingViewResponsesFiltered.find(r => r.id == row.id);
        setSelectedRow(rowTemp);
        setVMOperation(0);
        setOpen(true);
    }

    const ligarDesligarLinha = (row: any) => {
        let rowTemp = hostingViewResponsesFiltered.find(r => r.id == row.id);
        let testeStatus = rowTemp.situacao;

        if (rowTemp.situacao == 'Started') {
            setSelectedRow(rowTemp);
            setVMOperation(0);
            setOpen(true);
        } else if (rowTemp.situacao == 'Stopped') {
            setSelectedRow(rowTemp);
            setVMOperation(1);
            setOpen(true);
        } else {
            enqueueSnackbar("Situação não definida", {
                variant: 'warning',
                preventDuplicate: true,
                persist: false,
            })
        }
    }

    const deletarLinha = (row: any) => {
        let rowTemp = hostingViewResponsesFiltered.find(r => r.id == row.id);
        setSelectedRow(rowTemp);
        setOpenDelete(true);
    }

    const columns = [
        {
            field: 'nome', headerName: 'Nome', width: "49%",
            renderCell: (row: any) => {

                return (

                    row.nome || <i className="lci lci-divider-horizontal" />

                )
            }
        },
        {
            field: 'hostname', headerName: 'Nome interno', width: "20%",
            renderCell: (row: any) => {

                return (
                    <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', width: '100%' }}>
                        {row.hostname || <i className="lci lci-divider-horizontal" />} </div>

                )
            }
        },
        { field: 'assinaturaNome', headerName: 'Assinatura', width: "25%" },

        {
            field: 'situacao', headerName: 'Situação', width: "8%", overflow: "visible",
            renderCell: (row: any) => {
                switch (row.situacao) {
                    case 'Started':
                        return <p className='text-green'>Inicializado</p>;

                    case 'Stopped':
                        return <p className='text-danger'>Parado</p>;
                    default:
                        return row.situacao;
                }
            }
        },
        {
            field: 'id', width: 160, overflow: "visible",
            renderCell: (row: any) => {
                return (
                    <>
                        <LcIconLink icon="lci lci-link" size='small' tooltipPosition='right' tooltip="Conectar" onClick={() => conectarLinha(row)} />
                        <LcIconLink icon="ppi ppi-plus" size='small' tooltipPosition='right' tooltip="Abrir chamado" onClick={() => editarLinha(row)} />
                        <LcIconLink icon="lci lci-document-text" size='small' tooltipPosition='right' tooltip="Detalhes" onClick={() => detalhesLinha(row)} />
                        <LcIconLink icon={row.situacao == "Started" ? "lci lci-stop" : "lci lci-play"} size='small' tooltipPosition='right' tooltip={row.situacao == "Started" ? "Desligar" : "Ligar"} onClick={() => ligarDesligarLinha(row)} />
                    </>
                )
            }
        },
    ];

    const functionsRow = [
        {
            label: 'Listar discos',
            func: openVHDsLinha
        },
        {
            label: 'Excluir',
            func: deletarLinha
        }
    ]

    function SetShoModalAddVM(option: boolean) {
        setMessageSuccess('');
        setNewVM({});
        setShoModalAddVM(option)
    }

    const columnsTableModal = [
        { field: 'nome', headerName: 'Nome', width: "85%" },
        { field: 'tamanho', headerName: 'Tamanho', width: "15%" },
    ];

    const functionsGeneric = [
        {
            icon: 'ppi ppi-plus',
            tooltip: 'Criar VM',
            onClick: () => {
                service.GetContracts().then((response: { value: string, name: string }[]) => {
                    setContractsSelect(response);
                });

                service.RetrieveSubscriptionsSelectAzureAndArm().then((response: { value: string, name: string }[]) => {
                    setSubscriptionsSelect(response);
                })

                service.GetVmSizes().then((response: { value: string, name: string }[]) => {
                    setVMSizeSelect(response);
                });

                SetShoModalAddVM(true);
            }
        }
    ]

    const GetVms = (value) => {
        setVNetsSelect([]);
        setSubnetSelect([]);
        setVNetsLoading(true);
        service.GetVirtualNets(value).then((response: VNet[]) => {
            setVNets(response);
            var VNetsSelectTemp = response.map((item: VNet) => {
                return { value: item.id, name: item.name };
            });
            setVNetsSelect(VNetsSelectTemp);
        }).catch(error => {
            console.error(error);
        }).then(() => {
            setVNetsLoading(false);
        })
    }

    const filterVnets = (value) => {
        const VNetsTemp = VNets.filter((item: VNet) => {
            return item.id == value;
        });
        const VSubnetsTemp = VNetsTemp[0].properties.subnets.map((item: VNetSubnet) => {
            return { value: item.id, name: item.name };
        });
        setSubnetSelect(VSubnetsTemp);
    }

    //#region Criar VM
    const [newVM, setNewVM] = useState<VM>({});
    const [shoModalAddVM, setShoModalAddVM] = useState<boolean>(false);
    const handleFormAddVM = (event: any) => {
        setDisabledButton(false)
        const { name, value } = event;
        let _newVM = newVM as any;
        _newVM[name] = value;
        setNewVM(_newVM);

        if (name == 'name' && value) {
            setIsValidName(true)
            return;
        }

        switch (name) {
            case 'size':
                setIsValidSize(true)
                break;

            case 'signature':
                setIsValidSignature(true)
                GetVms(value)
                break;

            case 'subnet':
                setIsValidSubNet(true)
                break;

            case 'so':
                setIsValidSO(true)
                break;

            case 'contract':
                setIsValidContract(true)
                break;

            case 'environment':
                setIsValidEnvironment(true)
                break;

            case 'vnet':
                setIsValidVNet(true)
                filterVnets(value)
                break;
            default:
                break;
        }
    }

    const handleAddNewVM = async function () {
        if (!validateNewVM(newVM)) {
            setMessageSuccess('');
            setLoadingForm(true);
            service.CreateOrUpdate(newVM)
                .then(response => {
                    successMessage(response.data);
                    loadAllVMS();
                })
                .catch(error => {
                    errorMessage(error.response.data);
                    console.warn(error);
                })
                .then(() => {
                    setNewVM({});
                    setLoadingForm(false);
                    setShoModalAddVM(false);
                });

        }
        else {
            errorMessage('Preencha os campos em vermelho')
            return
        }
    }

    const [isValidSize, setIsValidSize] = useState<boolean>(true)
    const [isValidSignature, setIsValidSignature] = useState<boolean>(true)
    const [isValidVNet, setIsValidVNet] = useState<boolean>(true)
    const [isValidSubNet, setIsValidSubNet] = useState<boolean>(true)
    const [isValidSO, setIsValidSO] = useState<boolean>(true)
    const [isValidName, setIsValidName] = useState<boolean>(true)
    const [isValidContract, setIsValidContract] = useState<boolean>(true)
    const [isValidEnvironment, setIsValidEnvironment] = useState<boolean>(true)
    const [disabledButton, setDisabledButton] = useState<boolean>(false)

    const validateNewVM = (vm: any) => {
        let array: any[] = [];
        array.push(vm['size'] ? true : false)
        setIsValidSize(vm['size'] ? true : false)
        array.push(vm['signature'] ? true : false)
        setIsValidSignature(vm['signature'] ? true : false)
        array.push(vm['vnet'] ? true : false)
        setIsValidVNet(vm['vnet'] ? true : false)
        array.push(vm['subnet'] ? true : false)
        setIsValidSubNet(vm['subnet'] ? true : false)
        array.push(vm['so'] ? true : false)
        setIsValidSO(vm['so'] ? true : false)
        array.push(vm['name'] ? true : false)
        setIsValidName(vm['name'] ? true : false)
        array.push(vm['contract'] ? true : false)
        setIsValidContract(vm['contract'] ? true : false)
        array.push(vm['environment'] ? true : false)
        setIsValidEnvironment(vm['environment'] ? true : false)

        let disabled = false;
        array.forEach(element => {
            if (!element) { disabled = !element }
        });
        setDisabledButton(disabled)
        return disabled
    };

    const handleConfirmation = () => {

        const notNullOrEmpty = (string) => string !== undefined && string !== null && string != "";

        //Verificar nome digitado
        if (SelectedRow && SelectedRow.hostname.trim() == vmConfirmationName.trim()) {
            let _hostname = SelectedRow.hostname.trim();
            let _serviceName = notNullOrEmpty(SelectedRow.serviceName.trim()) ? SelectedRow.serviceName.trim() : _hostname;
            let _deploymentName = notNullOrEmpty(SelectedRow.deploymentName.trim()) ? SelectedRow.deploymentName.trim() : _hostname;
            let _virtualMachineName = notNullOrEmpty(SelectedRow.virtualMachineName.trim()) ? SelectedRow.virtualMachineName.trim() : _hostname;
            let _assinatura = SelectedRow.assinaturaAcessoId;

            if (VMOperation == 1) {
                warningMessage('Operação em andamento. Isso pode levar alguns segundos. Aguarde enquanto concluímos a tarefa. Você receberá uma mensagem quando estiver pronta.');
                setOpen(false);
                service.Ligar(_serviceName, _hostname, _deploymentName, _virtualMachineName, _assinatura)
                    .then((response) => {
                        const row = SelectedRow;
                        row.situacao = 'Started';
                        updateRowSituacao(row);
                        successMessage('Máquina virtual ligada com sucesso.');
                        return response;
                    })
                    .catch((error) => {
                        console.error(error);
                        let message = error;
                        try {
                            message = error && error.response && error.reponse;
                            message = error && error.response && error.response.data && error.reponse.data;
                        } catch (e) {

                        }
                        successMessage(`O acionamento remoto da VM ${SelectedRow.hostname} será realizado via chamado. Redirecionando para o registro da requisição desta ação.`);
                        setFormData({
                            title: `Ligar ${SelectedRow.hostname}`,
                            description: `Solicito que VM cujo hostname é: ${SelectedRow.hostname} seja ligada`,
                            gtmType: typeLC
                        });
                        setModalVisibleHeyHoCall(true)
                    })
                    .then(() => {
                        setVMConfirmationName('');
                    });
            }

            if (VMOperation == 0) {
                warningMessage('Operação em andamento. Isso pode levar alguns segundos. Aguarde enquanto concluímos a tarefa. Você receberá uma mensagem quando estiver pronta.');
                setOpen(false);
                service.Desligar(_serviceName, _hostname, _deploymentName, _virtualMachineName, _assinatura)
                    .then((response) => {
                        const row = SelectedRow;
                        row.situacao = 'Stopped';
                        updateRowSituacao(row);
                        successMessage('Máquina virtual desligada com sucesso.');
                        return response;
                    })
                    .catch((error) => {
                        console.error(error);
                        let message = error;
                        try {
                            message = error && error.response && error.reponse;
                            message = error && error.response && error.response.data && error.reponse.data;
                        } catch (e) {

                        }
                        successMessage(`O desligamento remoto da VM ${SelectedRow.hostname} será realizado via chamado. Redirecionando para o registro da requisição desta ação.`);

                        setFormData({
                            title: `Desligar ${SelectedRow.hostname}`,
                            description: `Solicito que VM cujo hostname é: ${SelectedRow.hostname} seja desligada`,
                            gtmType: typeLC
                        });
                        setModalVisibleHeyHoCall(true)
                    })
                    .then(() => {
                        setVMConfirmationName('');
                    });
            }
        } else {
            setOpen(false);
            setVMConfirmationName('');
            enqueueSnackbar('O nome do host da máquina virtual digitado não confere com o selecionado', {
                variant: 'warning',
                preventDuplicate: true,
                persist: false
            })
        }


    }

    const handleConfirmCloseDelete = (confirm: boolean) => {
        if (confirm == true) {
            deleteMachine(SelectedRow)
        }
        setOpenDelete(false);
    };

    const closeButton = {
        show: true,
        onClose: () => setModalVisibleHeyHoCall(false)
    };

    const loadMore = (size?: number) => {
      /*  if (size) setVisibleHostingViewResponsesFiltered(hostingViewResponsesFiltered.slice(0, size))
        else setVisibleHostingViewResponsesFiltered([...visibleHostingViewResponsesFiltered, ...hostingViewResponsesFiltered.slice(visibleHostingViewResponsesFiltered.length, visibleHostingViewResponsesFiltered.length + 10)])
   */ };

    const onSortChange = (sortData: any) => {
        const { sort, size } = sortData;
        setFilterPage({ ...filterPage, column: sort.column, direction: sort.direction, size: size })

    };

    const loadMoreVhds = (size?: number) => {
        if (size) setVhds(vhds.slice(0, size))
        else setVhds([...vhds.slice(vhds.length, vhds.length + 10)])
    };

    const changeDensity = (density: string) => {
        dispatch({ type: 'PREF_UPDATE', payload: { name: "density", value: density } });
    }
    const [filterVisible, setFilterVisible] = useState(false);


    const opcoesSituacao = [
        { value: '', label: 'Todas' },
        { value: 'Started', label: 'Inicializado' },
        { value: 'Stopped', label: 'Parado' },
    ];

    const filterAdvanced = {
        fields: [
            { label: 'Nome', name: 'nome', type: 'text' },
            { label: 'Nome interno', name: 'hostname', type: 'text' },
            { label: 'Assinatura', name: 'assinaturaNome', type: 'text' },
            { label: 'Situação', name: 'situacao', type: 'select', options: opcoesSituacao },

        ],
        onChange: (updatedFilters, size) => {
            // Atualize o estado com os valores dos filtros
            updatedFilters.forEach(f => {
                if (f.name === 'nome') setFilter_nome(f.value);
                if (f.name === 'assinaturaNome') setFilter_assinaturaNome(f.value);
                if (f.name === 'situacao') setFilter_situacao(f.value);
                // ... outros filtros
            });
            setFilterPage({ ...filterPage, size: size });
        },
        visible: filterVisible,
        onChangeVisibility: () => setFilterVisible(!filterVisible)
    };

    const card = [
        {
            id: 1,
            type: 'Custom',
            bgColor: 'rgba(255,255,255,.7)',
            position: { ColSpan: 12, RowSpan: 12, row: 1, col: 1 },
            customContentRender: () => {
                return (
                    <LcLoading loading={isLoading} label='Carregando...'>

                        <LcInfiniteTable
                            loading={isLoading}
                            columns={columns}
                            rows={hostingViewResponsesFiltered}
                            filter={filterAdvanced}
                            size={hostingViewResponsesFiltered.length}
                            functionsRow={functionsRow}
                            loadMore={() => { }}
                            notLoadMore={true}
                            disableFilterModal={true}
                            onSortChange={onSortChange}
                            density={pref.data?.density || "medium"}
                        />
                    </LcLoading>
                )
            }

        }
    ]

    const filterSystem = () => {
        return (
            <FilterLcInfiniteTable
                filter={filterAdvanced.fields}
                onFilterChange={handleFilterChange}
            />
        );
    };


    const applyFilter = useCallback(() => {
        let isFilterActive = false;

        if (hostingViewResponses.length > 0) {
            let filtered = hostingViewResponses.filter(hosting => {
                const matchesNome = filter_nome
                    ? hosting.nome ? hosting.nome.toString().toLowerCase().includes(filter_nome.toLowerCase()) : false
                    : true;

                const matchesHostname = filter_hostname
                    ? hosting.hostname ? hosting.hostname.toString().toLowerCase().includes(filter_hostname.toLowerCase()) : false
                    : true;

                const matchesAssinaturaNome = filter_assinaturaNome
                    ? hosting.assinaturaNome.toString().toLowerCase().includes(filter_assinaturaNome.toLowerCase())
                    : true;

                const matchesSituacao = filter_situacao
                    ? hosting.situacao === filter_situacao
                    : true;

                return matchesNome && matchesHostname && matchesAssinaturaNome && matchesSituacao;
            });

            isFilterActive = filtered.length !== hostingViewResponses.length;
            setHostingViewResponsesFiltered(filtered);
            setHostingLength(filtered.length);
        }

        dispatch(setFilterActive(isFilterActive));
    }, [filter_nome, filter_hostname, filter_assinaturaNome, filter_situacao, hostingViewResponses, dispatch]);

    useEffect(() => {
        applyFilter();
    }, [applyFilter]);

    // UseEffect para limpar o filtro ativo quando o componente é desmontado
    useEffect(() => {
        return () => {
            dispatch(setFilterActive(false));
        };
    }, [dispatch]);


    const handleFilterChange = (updatedFilters) => {

        // Atualiza os estados com os valores dos filtros
        const NameFilter = updatedFilters.find(f => f.name === 'nome')?.value || '';
        const HostnameFilter = updatedFilters.find(f => f.name === 'hostname')?.value || '';
        const signatureFilter = updatedFilters.find(f => f.name === 'assinaturaNome')?.value || '';
        const situacaoFilter = updatedFilters.find(f => f.name === 'situacao')?.value || '';

        if (NameFilter !== filter_nome) setFilter_nome(NameFilter);
        if (HostnameFilter !== filter_hostname) setFilter_hostname(HostnameFilter);
        if (signatureFilter !== filter_assinaturaNome) setFilter_assinaturaNome(signatureFilter);
        if (situacaoFilter !== filter_situacao) setFilter_situacao(situacaoFilter);
    };

    return (
        <Layout
            pageTitle="Ambiente"
            functionsGeneric={functionsGeneric}
            dots={
                <>
                    <div className='item' style={{ color: pref.data?.density == "high" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("high")}><i className='ppi ppi-view-list' /> Densidade alta</div>
                    <div className='item' style={{ color: pref.data?.density == "medium" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("medium")}><i className='ppi ppi-menu' /> Densidade média</div>
                    <div className='item' style={{ color: pref.data?.density == "low" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("low")}><i className='ppi ppi-menu-alt-4' /> Densidade baixa</div>
                </>
            }
            gridFilter={{
                toggleVisibility: () => {
                    setFilterVisible(!filterVisible)
                },
                size: hostingLength
            }}
            // lastUpdate={hostingLastUpdate}
            lastUpdate={lastUpdate}
        >
            <Confirmation
                close={() => { setOpen(false); setVMConfirmationName(''); }}
                display={open}
                textBtnOk='Confirmar'
                textBtnCancel='Cancelar'
                title={`${VMOperation == 0 ? 'Desligar' : 'Ligar'} máquina virtual?`}
                text={
                    <>
                        <p className='mb-4'>Máquina virtual selecionada:</p>
                        <p className='ml-4'>Nome: <b>{SelectedRow?.nome}</b></p>
                        <p className='ml-4'>Host: <b>{SelectedRow?.hostname}</b></p>
                        <p className='mv-4'>Esta operação pode demorar um pouco. Tem certeza que deseja continuar?</p>
                        <p className='mv-4'>Digite o nome do <b>host</b> da máquina virtual escolhida para confirmar a operação de {VMOperation == 0 ? 'desligamento' : 'ligação'}.</p>
                        <PPInput type="text" required value={vmConfirmationName} onChange={event => setVMConfirmationName(event.target.value)} />
                    </>
                }
                confirm={() => handleConfirmation()}
            />

            <DialogConfirmForm
                onCloseEvent={handleConfirmCloseDelete}
                open={openDelete}
                confirmMessage='Confirmar'
                abortMessage='Cancelar'
                title="Excluir máquina virtual?"
                content='Esta operação pode demorar um pouco. Tem certeza que deseja continuar?'
            />

            <PPModal visible={modalVisibleDetails} title="Detalhes" onClose={() => setModalVisibleDetails(false)}>
                <p><b>Nome:</b> {hostingDetails?.nome}</p>
                <p><b>HostName:</b> {hostingDetails?.hostname}</p>
                <p><b>Situação:</b> {hostingDetails?.situacao}</p>
                <p><b>Tamanho:</b> {hostingDetails?.tamanho}</p>
                <p><b>IP Público:</b> {hostingDetails?.ipPublico}</p>
                <p><b>IP Privado:</b> {hostingDetails?.ipPrivado}</p>
                <p><b>DNS:</b> {hostingDetails?.nomePublico}</p>
                <p><b>Assinatura:</b> {hostingDetails?.assinaturaNome}</p>
            </PPModal>

            <HeyHoNewRequest 
                openModal={modalVisibleHeyHoCall} 
                onClose={() => setModalVisibleHeyHoCall(false)}
                formData={formData}
                needAtachmente
            />
            {/* <PPModal visible={modalVisibleHeyHoCall} title="Abertura de Chamado" onClose={() => setModalVisibleHeyHoCall(false)}>
                <HeyhoCall formData={formData} closeButton={closeButton}></HeyhoCall>
            </PPModal> */}

            <PPModal visible={modalVisible} title="VHDs" onClose={() => setModalVisible(false)}>
                <LcInfiniteTable
                    columns={columnsTableModal}
                    rows={vhds}
                    size={vhds.length}
                    loadMore={loadMoreVhds}
                />

            </PPModal>

            <PPModal title="Criar VM" visible={shoModalAddVM} onClose={() => { SetShoModalAddVM(false) }}
                functions={[
                    {
                        label: "Salvar",
                        onClick: handleAddNewVM,
                        disabled: disabledButton,
                        hidden: LoadingForm
                    }
                ]}
                loading={LoadingForm}
            >
                {
                    MessageSuccess != '' && <>
                        {
                            MessageSuccess.split('</br>').map((m, i) => {
                                return (<p key={i}>{m.replace('</br>', '')}</p>);
                            })
                        }
                    </>
                }
                <PPGrid style={{ paddingRight: "10px" }} container spacing={2}>
                    <PPGrid item xs={6} sm={6} md={6} lg={6}>
                        <SelectField className={isValidSize ? '' : 'errorField'} label="Tamanho" name="size" options={VMSizeSelect} onChange={handleFormAddVM} />
                    </PPGrid>
                    <PPGrid item xs={6} sm={6} md={6} lg={6}>
                        <SelectField className={isValidSignature ? '' : 'errorField'} label="Assinatura" name="signature" options={SubscriptionsSelect} onChange={handleFormAddVM} />
                    </PPGrid>
                    <PPGrid item xs={12} sm={12} md={12} lg={12}>
                        {
                            VNetsLoadings ?
                                <small className="text-primary">Carregando Vnets...</small>
                                :
                                VNetsSelect?.length == 0 &&
                                <small className="text-danger">Não há Vnets para a assinatura selecionada</small>
                        }
                    </PPGrid>
                    <PPGrid item xs={6} sm={6} md={6} lg={6}>
                        <SelectField className={isValidVNet ? '' : 'errorField'} label="Vnet" name="vnet" options={VNetsSelect} onChange={handleFormAddVM} />
                    </PPGrid>
                    <PPGrid item xs={6} sm={6} md={6} lg={6}>
                        <SelectField className={isValidSubNet ? '' : 'errorField'} label="Subnet" name="subnet" options={SubnetSelect} onChange={handleFormAddVM} />
                    </PPGrid>
                    <PPGrid item xs={6} sm={6} md={6} lg={6}>
                        <SelectField className={isValidSO ? '' : 'errorField'} label="Sistema Operacional" name="so" options={[{ value: 'windows', name: "Windows (Windows Server 2016 Datacenter)" }]} onChange={handleFormAddVM} />
                    </PPGrid>
                    <PPGrid item xs={12} sm={12} md={12} lg={11}>
                        <InputField className={isValidName ? '' : 'errorField'} name="name" type="text" value={newVM.name} label="Nome" pattern="[A-Za-z]{16}" onChange={handleFormAddVM} />
                    </PPGrid>
                    <PPGrid item xs={6} sm={6} md={6} lg={6}>
                        <SelectField className={isValidContract ? '' : 'errorField'} label="Contrato" name="contract" options={ContractsSelect} onChange={handleFormAddVM} />
                    </PPGrid>
                    <PPGrid item xs={6} sm={6} md={6} lg={6}>
                        <SelectField className={isValidEnvironment ? '' : 'errorField'} label="Ambiente" name="environment" options={[{ value: 'dev', name: "Desenvolvimento" }, { value: 'hml', name: "Homologação" }, { value: 'propd', name: "Produção" }]} onChange={handleFormAddVM} />
                    </PPGrid>
                </PPGrid>
            </PPModal>


            <LCDashboard
                cards={card}
                rightSidePanel={{
                    title: 'Filtros',
                    pinned: false,
                    show: filterVisible,
                    content: filterSystem,
                }}
            />


        </Layout>
    );
}

export default Hosting;